module.exports = __webpack_public_path__ + "img/word.bab6f616.svg";